"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ctrlOrShiftPressed = exports.metaOrCtrlPressed = exports.isMac = exports.getOs = exports.OS_LIST = exports.OS_NAME_LINUX = exports.OS_NAME_WINDOWS = exports.OS_NAME_MAC = void 0;
exports.OS_NAME_MAC = 'Mac';
exports.OS_NAME_WINDOWS = 'Windows';
exports.OS_NAME_LINUX = 'Linux';
exports.OS_LIST = [exports.OS_NAME_WINDOWS, exports.OS_NAME_LINUX, exports.OS_NAME_MAC]; // add your OS values
const getOs = () => exports.OS_LIST.find((v) => navigator.platform.indexOf(v) >= 0);
exports.getOs = getOs;
const isMac = () => (0, exports.getOs)() === exports.OS_NAME_MAC;
exports.isMac = isMac;
const metaOrCtrlPressed = ({ metaKey, ctrlKey }) => ((0, exports.isMac)() ? metaKey : ctrlKey);
exports.metaOrCtrlPressed = metaOrCtrlPressed;
const ctrlOrShiftPressed = (e) => (0, exports.metaOrCtrlPressed)(e) || e.shiftKey;
exports.ctrlOrShiftPressed = ctrlOrShiftPressed;
//# sourceMappingURL=os.js.map